import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../../store";
import { fetchConnections } from "../../../slices/connection";
import MobileTableStack from "../../base/MobileTableStack";

interface Props {
  handleEdit?: (id: number) => void;
  handleDelete?: (id: number) => void;
}

const ConnectionsStack: React.FC<Props> = (props) => {
  const { handleEdit, handleDelete } = props;

  const dispatch = useDispatch();
  const { connectionList } = useSelector((store) => store.connection);

  useEffect(() => {
    dispatch(fetchConnections());
  }, [dispatch]);

  const dataRows =
    connectionList &&
    connectionList.map((connection) => {
      let rowObject = {
        id: connection.id,
        name: connection.name,
        systemType: connection.systemType?.value,
        authenticationType: connection.authenticationType?.value,
        server: connection.server || connection.tenant,
      };

      return rowObject;
    });

  const headers = ["name", "systemType", "authenticationType", "server"];

  return dataRows?.length ? (
    <MobileTableStack
      rows={dataRows!}
      headers={headers}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  ) : (
    <></>
  );
};

export default ConnectionsStack;
